"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var networker_1 = require("@idp/networker");
var StateProvider_1 = require("./StateProvider");
var AuthenticateAndLoginResponseMapper_1 = require("../models/mappers/AuthenticateAndLoginResponseMapper");
var EndPointsLoginConfig_1 = require("./EndPointsLoginConfig");
var GetUserCurrentStateResponseMapper_1 = require("../models/mappers/GetUserCurrentStateResponseMapper");
var ValidatePasscodeResponseMapper_1 = require("../models/mappers/ValidatePasscodeResponseMapper");
var ReportingService_1 = require("./ReportingService");
var ValidatePasscodeResponseMapperV2_1 = require("../models/mappers/ValidatePasscodeResponseMapperV2");
var ValidateLoginTokenRequest_1 = require("../models/request/ValidateLoginTokenRequest");
var LoginApi = /** @class */ (function () {
    function LoginApi() {
        this.networker = new networker_1.Networker();
        this.reportingService = new ReportingService_1.default();
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
    }
    LoginApi.prototype.authenticateAndLogin = function (body) {
        this.reportingService.fireLoginUIFormSubmitEvent(body.saveUserId);
        return this.networker.post(EndPointsLoginConfig_1.default.authenticateAndLogin, body, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        })
            .then(function (response) {
            var json = response.json();
            return json;
        })
            .then(function (data) {
            console.log('THEN', data);
            return Promise.resolve(new AuthenticateAndLoginResponseMapper_1.AuthenticateAndLoginResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            // Analytics Code: form response for NewAccessIDForm
            // this.reportingService.fireNewAccessIDFormResponseEvent( true, 'Unexpected System failure', '400',
            //     body.desiredAccessId, ErrorTypeOption.Failure_System );
            // this.reportingService.firePageLoadEvent( PageUrls.ACCESSID_PAGE );
            console.log('catch', err);
            return Promise.reject(err);
        });
    };
    LoginApi.prototype.getUserCurrentState = function (channel, flowType, filter, selectedAccount) {
        console.log("LoginApi: getUserCurrentState " + channel + "/" + flowType + "/" + selectedAccount);
        var finalUrl = EndPointsLoginConfig_1.default.getUserCurrentState + '/' + channel + '/' + flowType;
        var prom;
        if (selectedAccount) {
            this.reportingService.genericFireFormSubmitEvent('Account_Selection');
            finalUrl = finalUrl + '/' + selectedAccount;
        }
        if (filter) {
            finalUrl = finalUrl + '?filter=' + filter;
        }
        prom = this.networker.get(finalUrl, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function (response) {
            return response.json();
        })
            .then(function (data) {
            console.log('getCurrentUserState data', data);
            return Promise.resolve(new GetUserCurrentStateResponseMapper_1.GetUserCurrentStateResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            console.log('getCurrentUserState catch', err);
            return Promise.reject(err);
        });
    };
    LoginApi.prototype.validatePasscode = function (body) {
        console.log("LoginApi: ValidatePasscodeRequest " + body.selectedASMIndex + " " + body.passcode);
        var finalUrl = EndPointsLoginConfig_1.default.validatePasscode;
        console.log("ValidatePasscode finalUrl  " + finalUrl);
        this.reportingService.genericFireFormSubmitEvent('Passcode');
        var prom;
        prom = this.networker.post(finalUrl, body, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function (response) {
            return response.json();
        })
            .then(function (data) {
            console.log('validatePasscode data', data);
            return Promise.resolve(new ValidatePasscodeResponseMapper_1.ValidatePasscodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            console.log('getCurrentUserState catch', err);
            return Promise.reject(err);
        });
    };
    LoginApi.prototype.validatePasscodeV2 = function (body) {
        // console.log( `LoginApi: ValidatePasscodeRequest ${body.selectedASMIndex} ${body.passcode}` );
        var finalUrl = EndPointsLoginConfig_1.default.validatePasscodeV2;
        console.log("ValidatePasscodeV2 finalUrl  " + finalUrl);
        console.log('validatePasscodeV2 =', body);
        this.reportingService.genericFireFormSubmitEvent('Passcode');
        var requestObj = {
            validatePasscode: body,
        };
        var prom;
        prom = this.networker.post(finalUrl, requestObj, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function (response) {
            return response.json();
        })
            .then(function (data) {
            console.log('validatePasscode data', data);
            return Promise.resolve(new ValidatePasscodeResponseMapperV2_1.ValidatePasscodeResponseMapperV2(data).getDataObject());
        })
            .catch(function (err) {
            console.log('getCurrentUserState catch', err);
            return Promise.reject(err);
        });
    };
    LoginApi.prototype.invalidateSession = function (idpctxLogout) {
        var _this = this;
        if (idpctxLogout === void 0) { idpctxLogout = false; }
        return new Promise(function (resolve, reject) {
            var finalUrl = EndPointsLoginConfig_1.default.invalidateSession +
                ("?idpctxlogout=" + (idpctxLogout ? 'true' : 'false'));
            var prom = _this.networker.get(finalUrl, {
                headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
            });
            prom.then(function (result) {
                resolve(true);
            }, function (result) {
                reject(false);
            });
        });
    };
    LoginApi.prototype.getFeatureDetails = function (featureName, userId, userRecognized, teams) {
        return __awaiter(this, void 0, void 0, function () {
            var finalUrl, featureTogglePromise, payload, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        finalUrl = this.getToggelUrl(userId, false, teams);
                        return [4 /*yield*/, this.networker.get(finalUrl, {
                                headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
                            })];
                    case 1:
                        featureTogglePromise = _a.sent();
                        return [4 /*yield*/, featureTogglePromise.json()];
                    case 2:
                        payload = _a.sent();
                        return [2 /*return*/, payload];
                    case 3:
                        error_1 = _a.sent();
                        console.log('login-ui feature toggle  data failed!!! ', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginApi.prototype.getToggelUrl = function (userId, userRecognized, teams) {
        var toggleUrl = EndPointsLoginConfig_1.default.toggleApi +
            ("?user_id=" + userId + "&user_recognized=" + userRecognized);
        toggleUrl = toggleUrl + (teams ? "&teams=" + teams : '');
        return toggleUrl;
    };
    LoginApi.prototype.validateLoginToken = function (token) {
        var request = new ValidateLoginTokenRequest_1.ValidateLoginTokenRequest(token);
        // console.log( `LoginApi: ValidatePasscodeRequest ${body.selectedASMIndex} ${body.passcode}` );
        var finalUrl = EndPointsLoginConfig_1.default.validateLoginToken;
        console.log("ValidatePasscodeV2 finalUrl  " + finalUrl);
        console.log('validatePasscodeV2 =', request);
        var prom = this.networker.post(finalUrl, request, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function (response) {
            return response.json();
        })
            .then(function (data) {
            console.log('validateLoginToken response data', data);
            return Promise.resolve(data);
        })
            .catch(function (err) {
            console.log('validateLoginToken catch', err);
            return Promise.reject(err);
        });
    };
    LoginApi.prototype.profileSessionRefresh = function () {
        console.log('login-ui :: LoginAPI :: profileSessionRefresh');
        var prom = this.networker.get(EndPointsLoginConfig_1.default.profileSessionRefresh, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function () {
            return true;
        }).catch(function (ex) {
            console.log("Error refreshing session, CAN BE SAFELY IGNORED", ex);
            return true;
        });
    };
    LoginApi.prototype.inFocus = function () {
        var finalUrl = EndPointsLoginConfig_1.default.inFocus;
        var prom = this.networker.get(finalUrl, {
            headers: EndPointsLoginConfig_1.default.getInitialHeaders(),
        });
        return prom.then(function (response) {
            return response.json();
        })
            .then(function (data) {
            console.log('inFocus response data', data);
            return Promise.resolve(data);
        })
            .catch(function (err) {
            console.log('inFocus catch', err);
            return Promise.reject(err);
        });
    };
    return LoginApi;
}());
exports.default = LoginApi;
//# sourceMappingURL=LoginApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/LoginApi.js
// module id = 75
// module chunks = 8